/**
 * @author Christine Movius
 * @desc multisite selector component for global use
 * @example <multisite-selector
 *               disabled="$ctrl.disabled"
 *               headerColor= "'gray' || 'arc-brand-primary' || 'arc-accept'"
 *               options="$ctrl.options"
 *               selected-option="$ctrl.selectedOption"
 *               selected-options="$ctrl.selectedOptions"
 *               selector-type="'websites' || 'hierarchies' || 'multiple'"
 *               on-select-option="$ctrl.onSelectOption(id)">
 *          </multisite-selector>
*/

import template from './multisiteSelector.html';

const multisiteSelector = {
  template,
  bindings: {
    disabled: '<',
    headerColor: '<',
    options: '<',
    selectedOption: '<',
    selectedOptions: '<',
    selectorType: '<',
    onSelectOption: '&',
    hideLabel: '<'
  }
};

export default function (ngModule) {
  ngModule.component('multisiteSelector', multisiteSelector);
}
